// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--nh4QV","heading":"heading--FhAf2","subtext":"subtext--h60g9","link":"link--kpet0","btn":"btn--V6P09","rotation":"rotation--mgbxU"};